import { SvgIcon } from "@/components/icon"
import { Modal as AntdModal, ModalProps } from "antd"
import { FC } from "react"

import Button from "@/components/button/Button"
import { WidthValues, useModalDarkContext } from "@/components/context/ModalDarkContext"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import "../../styles/modal-dark.less"

import { useGeneralContext } from "../context/GeneralContext"
import watermarkImg from "./assets/easetech-watermark.svg"

const ModalDark: FC<ModalProps> = ({ children, ...baseProps }) => {
  const { setIsModalDarkOpen, widthDarkModal, modalDarkMode, modalDarkTypes, isLogo, centered, topOffset } =
    useModalDarkContext()
  const { xxl, xl, lg, md, sm } = useBreakpoint()
  const { setProjectGeometryInfo } = useGeneralContext()
  const defaultWidth = xxl ? "70vw" : xl ? "70vw" : lg ? "70vw" : md ? "70vw" : sm ? "85vw" : "90vw"

  const computedWidth = widthDarkModal ? WidthValues[widthDarkModal] || defaultWidth : defaultWidth

  const handleCancel = () => {
    setIsModalDarkOpen(false)
    // Assistance info stays reopenable from the page while the geometry is still invalid
    if (modalDarkTypes !== "assistance-info") {
      setProjectGeometryInfo(null)
    }
  }

  // if (!modalDarkTypes) return null

  return (
    <AntdModal
      footer={false}
      title={null}
      className={`modal-dark ${modalDarkMode}`}
      centered={centered}
      width={computedWidth}
      style={{ top: topOffset }}
      closeIcon={
        <div className={"close-icon-wrapper"}>
          <Button
            className={"close-icon"}
            btnType={"icon"}
            onClick={handleCancel}
            icon={<SvgIcon type={"close-modal"} />}
          />
        </div>
      }
      onCancel={handleCancel}
      destroyOnClose
      // The delete confirmation must never end up behind another open dialog. antd modals all sit at z-index 1000,
      // where whichever was mounted first ends up below, so pin this one on top (still under dropdowns and messages).
      zIndex={modalDarkTypes === "delete-confirmation" ? 1001 : undefined}
      {...baseProps}
    >
      {isLogo && (
        <div className={"watermark-wrapper"}>
          <img src={watermarkImg} alt={"watermark"} />
        </div>
      )}

      {children}
    </AntdModal>
  )
}

export default ModalDark
